export function filterLaktacijosZymes(laktacijos) {
  if (laktacijos.length === 5) return []; // No need to map if all are selected

  return laktacijos
    .map((id) => {
      switch (id) {
        case 1:
          return "1";
        case 2:
          return "2";
        case 3:
          return "3";
        case 4:
          return "4-5";
        case 5:
          return "5+";
        default:
          return null;
      }
    })
    .filter(Boolean); // Removes any null values
}
